import React, { useMemo } from 'react';
import FilterDropdown from './Filter/components/FilterDropdown';
import { translate } from '../services/translate';
import moment from 'moment';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    month?: number;
    year?: number;
    zIndex: number;
}

export default function DayOfMonthDropdown({ setValue, value, zIndex, month = moment().month(), year = moment().year() }: Props) {
    const items = useMemo(() => {
        const currentMonth = moment().year(year).month(month);
        const startDay = currentMonth.startOf('month').date();
        const endDay = currentMonth.endOf('month').date();

        const days = [];
        for (let year = startDay; year <= endDay; year++) {
            days.push({
                label: year.toString(),
                value: year,
            });
        }
        return days;
    }, [month, year]);

    return (
        <FilterDropdown
            label={translate('dayOfMonth')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
        />
    );
}
